import React from 'react';
import PropTypes from 'prop-types';
// Local Deps
import './AdminMenu.scss';
// import msgs from '../../config/messages';
// import NFButton from '../primitives/NFButton';
import AdminCaps from '../../config/searchFilters/AdminFilters';

// Components
import FilterGroup from '../FilterGroup';

export default class AdminMenu extends React.PureComponent {
  static propTypes = {
    selectedMenu: PropTypes.object,
    onMenuClick: PropTypes.func,
    auth: PropTypes.shape({
      role: PropTypes.string,
    }),
    // onToolFilter: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedMenu: { value: 'viewUsers' },
    onMenuClick: () => { },
    auth: { role: 'COMMON_USER' },
  };

  // _clearPartNumDes = () => {
  //   document.getElementById('partNum').value = '';
  //   document.getElementById('description').value = '';
  // };
  // _clearNiinDesc = () => {
  //   document.getElementById('niin').value = '';
  //   document.getElementById('description').value = '';
  // };
  // _clearNiinPartNum = () => {
  //   document.getElementById('niin').value = '';
  //   document.getElementById('partNum').value = '';
  // };

  // _clearFilters = () => {
  //   window.location.reload();
  // };

  render() {
    const { selectedMenu, onMenuClick, auth } = this.props;
    const adminConfig = {
      ...AdminCaps,
      filters: AdminCaps.getFilters ? AdminCaps.getFilters(auth.role) : AdminCaps.filters,
    };

    return (
      <div className="nf-solicitations-menu">
        <FilterGroup
          {...adminConfig}
          onFilterClick={onMenuClick}
          selectedFilter={[selectedMenu.value]}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminMenu/AdminMenu.jsx